export enum RunModeEnum {
    IndependentAggregator = 'IndependentAggregator',
    Supplier = 'Supplier',
}

export enum StageEnum {
    DayAhead = 'DayAhead',
    Intraday = 'Intraday',
}

export enum RunStatusEnum {
    Running = 'Running',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Failed = 'Failed',
    NotStarted = 'NotStarted',
}

export enum FlexIndexGranularityEnum {
    Day = 'Day',
    Month = 'Month',
    Year = 'Year',
}
